import { render, staticRenderFns } from "./RelatorioDadosCampanhas.vue?vue&type=template&id=32ee85c6"
import script from "./RelatorioDadosCampanhas.vue?vue&type=script&lang=js"
export * from "./RelatorioDadosCampanhas.vue?vue&type=script&lang=js"
import style0 from "./RelatorioDadosCampanhas.vue?vue&type=style&index=0&id=32ee85c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports